import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClipboard, FiTarget, FiEdit3, FiEye, FiRocket } = FiIcons;

const steps = [
  { icon: FiClipboard, title: "Request a Quote", desc: "Submit your practice details for a positioning analysis." },
  { icon: FiTarget, title: "Alignment", desc: "We align on your authority goals and target local market." },
  { icon: FiEdit3, title: "Build Phase", desc: "Our team architects your custom copy and authority design." },
  { icon: FiEye, title: "Review", desc: "You review the live draft. We refine until it's perfect." },
  { icon: FiRocket, title: "Launch", desc: "Handover and live deployment to your domain." }
];

const Process = () => {
  return (
    <div id="process" className="text-center">
      <div className="mb-20">
        <h2 className="text-4xl md:text-5xl font-bold text-white font-display mb-6">A Calm, Professional Process</h2>
        <p className="text-slate-400 max-w-2xl mx-auto">We respect your time. Our framework is designed for minimal friction and maximum authority.</p>
      </div>

      <div className="grid md:grid-cols-5 gap-8 relative">
        <div className="hidden md:block absolute top-[28px] left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" />
        {steps.map((step, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: idx * 0.1 }}
            className="relative"
          >
            <div className="w-14 h-14 rounded-full glass border-white/10 flex items-center justify-center mx-auto mb-6 bg-[#0a0c10] relative z-10">
              <SafeIcon icon={step.icon} className="text-2xl text-blue-500" />
            </div>
            <h3 className="text-lg font-bold text-white mb-3 font-display">{step.title}</h3>
            <p className="text-slate-500 text-xs leading-relaxed px-4">{step.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Process;